import React from 'react';

export default function AIIcon() {
	return (
		<svg
			className="fill-indigo-600"
			viewBox="0 0 14 14"
			width="14"
			height="14"
			style={{ marginRight: 8 }}
		>
			<path
				fillRule="evenodd"
				d="M5.25 2.625a.437.437 0 01.42.317l.474 1.662a2.25 2.25 0 001.546 1.546l1.662.474a.437.437 0 010 .84l-1.662.474a2.25 2.25 0 00-1.546 1.546l-.474 1.662a.437.437 0 01-.84 0l-.474-1.662a2.25 2.25 0 00-1.546-1.546l-1.662-.474a.437.437 0 010-.84l1.662-.474A2.25 2.25 0 004.38 4.604l.474-1.662a.437.437 0 01.396-.317zM10.5 .875a.437.437 0 01.425.331l.151.605c.14.56.582 1.002 1.142 1.142l.605.151a.437.437 0 010 .849l-.605.151a1.575 1.575 0 00-1.142 1.142l-.151.605a.437.437 0 01-.849 0l-.151-.605a1.575 1.575 0 00-1.142-1.142l-.605-.151a.437.437 0 010-.849l.605-.151c.56-.14 1.002-.582 1.142-1.142l.151-.605A.437.437 0 0110.5.875zM9.625 8.75a.437.437 0 01.415.298l.23.69c.088.26.3.466.568.568l.69.23a.437.437 0 010 .828l-.69.23a.875.875 0 00-.568.568l-.23.69a.437.437 0 01-.828 0l-.23-.69a.875.875 0 00-.568-.568l-.69-.23a.437.437 0 010-.828l.69-.23c.26-.088.466-.3.568-.568l.23-.69a.437.437 0 01.415-.298z"
				clipRule="evenodd"
			></path>
		</svg>
	);
}
